import type { ReactNode } from 'react';

type QuoteProps = {
  children: ReactNode;
  by: string;
  role?: string;
  /** `lg` — large standalone quote (home). `md` — smaller size for the testimonials grid. */
  size?: 'lg' | 'md';
};

/**
 * Italic Fraunces quote + uppercase attribution, matching the mockup's `.tq`/`.quote`.
 * `lg` uses the shared `.t-quote` scale (`clamp(24px,7vw,40px)`); `md` uses the
 * testimonials-grid scale (`clamp(21px,5vw,27px)`) — not covered by a shared
 * utility class, so it's defined inline here.
 */
export const Quote = ({ children, by, role, size = 'lg' }: QuoteProps) => {
  const isLarge = size === 'lg';

  return (
    <div className={isLarge ? 'max-w-[26ch]' : ''}>
      <p
        className={
          isLarge
            ? 't-quote mb-[22px]'
            : 'font-display mb-4 text-[clamp(21px,5vw,27px)] leading-[1.38] italic'
        }
      >
        {children}
      </p>
      <div className={isLarge ? 'border-line border-t pt-[30px]' : ''}>
        <p className="text-ink-soft text-[11.5px] font-semibold tracking-[.16em] uppercase">
          {by}
          {role ? (
            <>
              {' '}
              · <span className="text-primary-deep">{role}</span>
            </>
          ) : null}
        </p>
      </div>
    </div>
  );
};
